
import { useState, useEffect } from 'react';

/**
 * Hook para detectar si el dispositivo es móvil
 */
export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    // Función para detectar si es un dispositivo móvil
    const checkIsMobile = () => {
      // Chequeamos el user agent primero
      const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
      const isMobileUserAgent = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
        userAgent.toLowerCase()
      );
      
      // Chequeamos también el tamaño de pantalla (menos de 768px se considera móvil)
      const isMobileSize = window.innerWidth <= 768;
      
      // También detectamos capacidades touch nativas
      const hasTouchScreen = 'ontouchstart' in window || 
                            navigator.maxTouchPoints > 0 || 
                            (navigator as any).msMaxTouchPoints > 0;
      
      // Para solucionar problema de flechitas input number
      if (isMobileSize || isMobileUserAgent || hasTouchScreen) {
        document.documentElement.style.setProperty('--show-input-arrows', 'auto');
        document.documentElement.classList.add('mobile-device');
      } else {
        document.documentElement.style.setProperty('--show-input-arrows', 'auto');
        document.documentElement.classList.remove('mobile-device');
      }
                            
      // Consideramos móvil si: user agent indica móvil O (tamaño móvil Y tiene capacidades touch)
      const result = isMobileUserAgent || (isMobileSize && hasTouchScreen);
      console.log("Detección de dispositivo móvil:", {
        isMobileUserAgent,
        isMobileSize,
        hasTouchScreen,
        resultado: result
      });
      
      setIsMobile(result);
    };

    // Verificar inmediatamente
    checkIsMobile();

    // Actualizar al cambiar el tamaño de la ventana
    window.addEventListener('resize', checkIsMobile);

    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  return isMobile;
};
